import dimensionsStore from "component/data/dimensionsStore";
import Stateless from "component/Stateless";
import * as React from "react";

export interface LoadingProps {}

export default class Loading extends Stateless<LoadingProps> {
  public render() {
    const { width, height } = dimensionsStore;

    const left = width / 2 - 50;
    const loadingClassName = `loading-animation-div jump-pulse`;
    return (
      <div style={{ zIndex: 99999 }}>
        <div className="mask-div" />
        <div className={loadingClassName} style={{ left }}>
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    );
  }
}
